import React, { useContext } from 'react'
import { JourneyContext } from '../context/journeyContext'
import DOMPurify from 'dompurify'


export default function ComponentTextParagraph(props) {
   const [journeyState, setJourneyState] = useContext(JourneyContext)
   const sanitizedContent = DOMPurify.sanitize(props.data.Content);

    return (
         <>
            <label className="inp-label">
            </label>
            <div dangerouslySetInnerHTML={{"__html":sanitizedContent}}></div>
         </>
        )

}
